import React from "react";

export const MultiplierIcon = () => {
  return (
    <svg
      width={11}
      height={10}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 12 6 6m6 6 6 6m-6-6 6-6m-6 6-6 6"
      />
    </svg>
  );
};
